/** A run's status vocabulary, and what a launch defaults to and is capped at. */

import { EvalRunStatus } from "~/pages/manifold-nextgen/types/eval-run";

/**
 * Badge tints for a run's lifecycle status. Hues are limited to the set
 * `styles/design-system.css` inverts under `.dark`, so they need no `dark:` variant.
 */
export const RUN_STATUS_CONFIG = {
  [EvalRunStatus.PENDING]: {
    label: "Pending",
    badgeClass: "bg-gray-100 text-gray-700 border-gray-300",
  },
  [EvalRunStatus.RUNNING]: {
    label: "Running",
    badgeClass: "bg-blue-100 text-blue-700 border-blue-300",
  },
  [EvalRunStatus.SUCCEEDED]: {
    label: "Succeeded",
    badgeClass: "bg-green-100 text-green-700 border-green-300",
  },
  [EvalRunStatus.FAILED]: {
    label: "Failed",
    badgeClass: "bg-red-100 text-red-700 border-red-300",
  },
} as const satisfies Record<EvalRunStatus, { label: string; badgeClass: string }>;

export const RUN_STATUS_FILTER_OPTIONS = [
  { value: "all", label: "All statuses" },
  { value: EvalRunStatus.SUCCEEDED, label: "Succeeded" },
  { value: EvalRunStatus.FAILED, label: "Failed" },
  { value: EvalRunStatus.RUNNING, label: "Running" },
  { value: EvalRunStatus.PENDING, label: "Pending" },
] as const;

/** UI-only sentinel for an unset Radix `Select` filter (it has no "" value). */
export const ALL_FILTER = "all";

/**
 * Defaults for the launch form, mirroring `RunParameters` in
 * `conversations_types.evals`.
 */
export const LAUNCH_DEFAULTS = {
  iterations: 1,
  max_concurrency: 10,
  rewrite_queries: false,
  keep_conversations: false,
} as const;

/** `EvalRunnerSettings.eval_runner_max_concurrent_runs` default, for copy only. */
export const LAUNCH_CONCURRENT_RUN_CAP = 3;

/** `RunParameters.max_concurrency`'s bound, mirrored so the field refuses it first. */
export const LAUNCH_MAX_CONCURRENCY = 50;

/** `RunParameters.iterations`'s bound, mirrored so the field refuses it first. */
export const LAUNCH_MAX_ITERATIONS = 20;
